module.exports = __webpack_public_path__ + "img/mod-features.3bb96c45.webp";